// *******~ Import ~******** //
//? React
import { useContext } from "react";
//? Assets
// import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import Image from "react-bootstrap/Image";
//? Components
// import Social from "../home/components/social";
import ThemeContext from "../../common/theme/components/contexts/themecontexts";
import myResumePDF from "../../common/assets/prathivan-resume.pdf";

//? CSS
import "./contact.scss";
//? Images
import Photo from "./img/prathivan.jpeg";
import BGImg from "./img/bg1.jpg";

//? JSON File

//? Icons
import { FaChevronLeft } from "react-icons/fa";
import { IoMailOutline } from "react-icons/io5";
import { VscCallIncoming } from "react-icons/vsc";
import { CiCalendar } from "react-icons/ci";
import { SlGraduation } from "react-icons/sl";
import { IoLocationSharp } from "react-icons/io5";
import { PiToolboxLight } from "react-icons/pi";
import { LuDownload } from "react-icons/lu";
// *******~ Import ~******** //

function Contact({ Contactshow, setContactshow }) {
  const handleClose = () => setContactshow(false);
  const { theme } = useContext(ThemeContext);
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = myResumePDF;
    link.download = "prathivan-resume.pdf"; // Change the filename as needed
    link.click();
  };
  return (
    <>
      <Offcanvas
        show={Contactshow}
        onHide={handleClose}
        placement="end"
        className={`contact-canva ${theme === "dark" && "dark-theme"}`}
      >
        <Offcanvas.Body>
          <div className="content">
            <div className="header-img">
              <div className="overlay"></div>
              <Image src={BGImg} fluid />
              <span className="back-btn" onClick={handleClose}>
                <FaChevronLeft />
              </span>
            </div>
            <div className="heading">
              {/* <Image src={BGImg} fluid className="bg-img" /> */}

              <Image src={Photo} fluid className="profile" />
              <h3>Prathivan T</h3>
              {/* <p>React Native Developer | React JS Developer</p> */}
              <p>ERP Developer</p>
              <span className="location">
                <IoLocationSharp /> Najran, Saudi Arabia
              </span>
              {/* <Social /> */}
            </div>
            <div className="details">
              <ul>
                <li>
                  <span>
                    <PiToolboxLight />
                  </span>
                  1+ Years of Experience
                </li>
                <li>
                  <span>
                    <IoMailOutline />
                  </span>
                  <a href="mailto:prathivanthirunavukkarasu98@gmail.com">
                     prathivanthirunavukkarasu98@gmail.com
                  </a>
                </li>
                <li>
                  <span>
                    <VscCallIncoming />
                  </span>
                  {/* <a href="tel:+918610076287">+91 8610076287</a>,  */}
                  <a href="tel:+966508653241">+966 508653 241</a>
                </li>
                <li>
                  <span>
                    <CiCalendar />
                  </span>
                  21 May, 1998
                </li>
                <li>
                  <span>
                    <SlGraduation />
                  </span>
                  B.E in Mechanical Engineering
                </li>
              </ul>
            </div>
            <div className="download-cv">
              <button onClick={handleDownload}>
                <LuDownload />
                Download CV
              </button>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default Contact;
